import React, { useState, useCallback, useEffect } from "react";
import { Switch, Router, Route, Redirect } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./App.css";

import Header from "./Header";
import Upload from "./Upload";
import Wallet from "./Wallet";
import NFT from "./NFT";

import history from "./history";

import tokenAbi from "./contracts/NFT.json";
import factoryAbi from "./contracts/WalletFactory.json";

const Web3 = window.Web3;

const netId = 4;

function App() {
  const [account, setAccount] = useState(null);
  const [tokenContract, setTokenContract] = useState(null);
  const [factoryContract, setFactoryContract] = useState(null);

  const connectWeb3 = useCallback(async () => {
    // Modern dapp browsers...
    if (window.ethereum) {
      console.log("Using Ethereum enabled browser");
      window.web3 = new Web3(window.ethereum);

      window.web3.eth.transactionConfirmationBlocks = 1; //Hard code number of blocks needed
      let contract;
      contract = new window.web3.eth.Contract(
        tokenAbi.abi,
        tokenAbi.networks[netId].address
      );
      setTokenContract(contract);

      contract = new window.web3.eth.Contract(
        factoryAbi.abi,
        factoryAbi.networks[netId].address
      );
      setFactoryContract(contract);

      try {
        await window.ethereum.enable();
        setAccount(window.ethereum.selectedAddress);

        //If accounts change
        window.ethereum.on("accountsChanged", accounts => {
          if (accounts.length > 0) setAccount(accounts[0]);
          else {
            setAccount(null);
          }
        });
      } catch (error) {
        console.error("You must approve this dApp to interact with it");
      }
    }
    // Non-dapp browsers...
    else {
      alert("Please Install Metamask");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    connectWeb3();
  }, [connectWeb3]);

  const routes = (
    <Switch>
      <Route path="/" exact>
        <Upload />
      </Route>
      <Route path="/wallet" exact>
        <Wallet account={account} factoryContract={factoryContract} />
      </Route>
      <Route path="/nft" exact>
        <NFT account={account} tokenContract={tokenContract} />
      </Route>
      <Redirect to="/" />
    </Switch>
  );

  return (
    <Container>
      <Router history={history}>
        <Header account={account} connectWeb3={connectWeb3} />
        {routes}
      </Router>
    </Container>
  );
}

export default App;
